import { render, staticRenderFns } from "./PieCharts.vue?vue&type=template&id=87b55c74"
import script from "./PieCharts.vue?vue&type=script&lang=js"
export * from "./PieCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports